export class SellerBalanceModel {
    sellerId: string;
    sellerParentId: string;
    name: string = "";
    realName: string = "";
    balance: number = 0;
    loadingListAction: boolean = false;

    constructor(s?:Partial<SellerBalanceModel>) {
        Object.assign(this, s)   
    }
}
